
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M5.29 38.5l-3.42-6.09h36.26l-3.42 6.09H5.29zM9.14 32.26a8.87 8.87 0 01-3-6.69V12.12h25.19v13.45a8.9 8.9 0 01-3.19 6.83"}}),_c('path',{attrs:{"d":"M30.59 15.62h6.26V21c0 3.74-6 6.59-6 6.59M13.44 3.12v5.35M18.72.5v7.97M23.99 3.12v5.35M31.52 24h-25","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}})])
          )
        }
      }
    